import { isDefinedString, reduce } from "et3-type-guards";
import i18n from "../../../../../../constants/i18n";
import getUserAdvancedStore from "../../../../../../stores/user-store/advanced-store";
import Et3Image from "../../../../../../core/et3-Image";
import { withLiteObserverAndTheme } from "../../../../../../core/et3-enhanced-render";
import ET3Div from "../../../../../../core/et3-div";
import Et3Text from "../../../../../../core/et3-text";
import { SURFACE_SHADOW } from "../../../../../../core/et3-theme/surface-constants";
import {
  SELFIE_PILL_FONT_SIZE,
  SELFIE_PILL_HEIGHT,
  SELFIE_PILL_LETTER_SPACING,
  SELFIE_PILL_PADDING,
  SELFIE_PILL_RADIUS_CSS
} from "./image-column-constants";

const UserImageStatus = withLiteObserverAndTheme((props) => {
  const { theme } = props;
  const { colors, unitX } = theme;
  const userID = getUserAdvancedStore().currentUserId.get();
  const pictures = reduce(
    () => getUserAdvancedStore().userData.get(userID).pictures,
    []
  );
  const userAlbumIndex = getUserAdvancedStore().userAlbumIndex.get();
  const { profilePictureStatus, selfieVerified, isPictureActive, source } =
    getUserAdvancedStore().getImageData(pictures[userAlbumIndex]);
  const imageSource = getUserAdvancedStore().getImageSource(
    isPictureActive,
    profilePictureStatus
  );

  return isDefinedString(source) ? (
    <ET3Div
      isScrollable={false}
      isExtendable={false}
      fDirection="column-reverse"
      alignItems="flex-start"
      justifyContent="flex-start"
      withShadow={false}
      width={224}
      height={40}
      color={colors.all.transparent}
      style={{
        position: "absolute",
        display: "flex",
        flexWrap: "wrap",
        alignContent: "space-around"
      }}
      onClick={() => {}}
    >
      {selfieVerified === "Y" ? (
        <ET3Div
          isScrollable={false}
          isExtendable={false}
          fDirection="row"
          alignItems="center"
          justifyContent="center"
          withShadow={false}
          width={0}
          height={SELFIE_PILL_HEIGHT}
          color={colors.all.white}
          style={{
            boxSizing: "border-box",
            width: "auto",
            flexShrink: 0,
            whiteSpace: "nowrap",
            border: `1px solid ${colors.all.green}`,
            borderRadius: SELFIE_PILL_RADIUS_CSS,
            paddingLeft: SELFIE_PILL_PADDING * unitX,
            paddingRight: SELFIE_PILL_PADDING * unitX,
            boxShadow: SURFACE_SHADOW
          }}
          onClick={() => {}}
        >
          <Et3Text
            text={i18n.get("SELFIE_VERIFIED")}
            fontFamily={"BOLD"}
            fontSize={SELFIE_PILL_FONT_SIZE}
            isSpan={true}
            color={colors.all.green}
            style={{
              margin: 0,
              textTransform: "uppercase",
              letterSpacing: SELFIE_PILL_LETTER_SPACING
            }}
          />
        </ET3Div>
      ) : null}
      <Et3Image
        type="LOCAL"
        alt={i18n.get("USER_ALBUM_PICTURES")}
        imageName={imageSource}
        size={40}
        onClick={() => {}}
        style={{}}
      />
    </ET3Div>
  ) : null;
});
export default UserImageStatus;
